/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

'use strict';

import { LoggerServiceFactory } from "src/app/common/logging/LoggerServiceFactory";

export default function Row(data) {
	this.logger = LoggerServiceFactory.create('Row');
	if (!data || !data.startY) { throw new Error('Invalid data parameter in Row constructor.'); }
	this.list = data.list || [];
	this.startY = data.startY;
	this.finishY = data.finishY;
	this.height = this.getHeight();
	this.forceX = data.forceX || false;
}

Row.prototype.add = function(thing) {
	this.list.push(thing);
};

Row.prototype.getById = function(id) {
	let l = this.list.length;
	for (let i = 0; i < l; i++) {
		if (this.list[i].$id === id) { return this.list[i]; }
	}
	// No match.
	return false;
};

Row.prototype.getHeight = function() {
	return this.finishY - this.startY;
};

Row.prototype.inBounds = function(thingPos) {
	let center = thingPos.top + thingPos.height / 2;
	return (center >= this.startY && center <= this.finishY);
};

Row.prototype.align = function(id) {
	if (this.forceX) { this.startY = this.forceX; }
	let thing = this.getById(id);
	if (thing) {
		thing.data.top = this.startY;
	} else {
		this.alignAll();
	}
};

Row.prototype.alignAll = function() {
	if (this.forceX) { this.startY = this.forceX; }
	let self = this;
	this.list.forEach(function(thing) {
		thing.data.top = self.startY;
	});
};

Row.prototype.save = function() {
	let fbChangedTickets = [];
	this.list.forEach(function(ticket) {
		fbChangedTickets.push({
			'id': ticket.$id,
			'top': ticket.data.top,
			'left': ticket.data.left
		});
	});
	return fbChangedTickets;
};

Row.prototype.calculateMode = function(numberList) {
	let count = -100000;
	let countMap = { };
	let result;
	for (let i = 0; i < numberList.length; i++) {
		countMap[numberList[i]] = (countMap[numberList[i]] || 0) + 1;
		if (countMap[numberList[i]] > count) {
			count = countMap[numberList[i]];
			result = numberList[i];
		}
	}
	return result;
};

Row.prototype.verify = function(activeLineX) {
	let self = this;
	let cnfCount = 0;
	this.list.forEach(function(ticket) {
		for (let i = 0; i < self.list.length; i++) {
			if (ticket.$id === self.list[i].$id) { continue; }
			if (ticket.data.left === self.list[i].data.left && ticket.data.top === self.list[i].data.top) {
				cnfCount++;
				if (activeLineX && ticket.data.left < activeLineX) {
					self.logger.log('Active Side');
					ticket.data.top += (50 * cnfCount);
				} else {
					self.logger.log('Pull Side');
					ticket.data.left += (50 * cnfCount);
				}
			}
		}
	});
};
